<nav class="navbar-expand-lg navbar-subsite" role="navigation">
  <div class="container-fluid">

    <div class="collapse navbar-collapse font-gotham">
        <ul class="nav navbar-nav" *appUserRoleUp="[ Role.Admin, Role.Vendor, Role.User ]">

          <li class="nav-item col-sm-4" *appUserRoleUp="[ Role.Admin, Role.User ]" routerLink="/projects">
            <a class="nav-link text-white fixed-width-link">Projects</a>
          </li>

          <li class="nav-item col-sm-4" *appUserRoleUp="[ Role.Admin, Role.Vendor, Role.User ]" routerLink="/equipments">
            <a class="nav-link text-white fixed-width-link">Equipment</a>
          </li>

          <li class="nav-item col-sm-4" *appUserRoleUp="[ Role.Admin, Role.User ]" routerLink="/purchase-orders">
            <a class="nav-link text-white fixed-width-link">Purchase Orders</a>
          </li>
        </ul>
      </div>
  </div>
</nav>